import { Routes } from '@angular/router';

import { provideBlogCms } from '@stair-craft/blog/data-access';

// Статьи блога читаются клиентом пакета CMS: его провайдеры объявлены на разделе, а не в
// приложении, и пакет грузится вместе с разделом.
const routes: Routes = [
    {
        path: '',
        providers: provideBlogCms(),
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadComponent: () => import('@stair-craft/blog/list'),
                data: {
                    seoTitle: $localize`:@@seoBlogTitle:Справочник — GoldenCalc`,
                    seoDescription: $localize`:@@seoBlogDesc:Параметры конструктора, нормы и расчёты — справочник по проектированию деревянных лестниц от команды GoldenCalc.`,
                },
            },
            {
                path: ':slug',
                loadComponent: () => import('@stair-craft/blog/article'),
            },
        ],
    },
];

export default routes;
